import { Component, ViewChild } from '@angular/core';
import {
  IonicPage,
  NavController,
  NavParams,
  ViewController,
} from 'ionic-angular';

import { AnalyticsProvider } from '../../providers/analytics/analytics';
import { OpsProvider } from '../../providers/ops/ops';
import { OpsVehicleModel } from './../../models/vehicle.ops';
import { UserModel } from '../../models/user';

@IonicPage()
@Component({
  selector: 'vehicle-places-autocomplete',
  templateUrl: 'vehicle-autocomplete.html',
})
export class VehicleAutocompletePage {
  MAX_SEARCH_RESULTS = 50;

  vehicles: OpsVehicleModel[] = [];
  query: string;
  type: 'vin' | 'license' | 'serial_number';
  account: UserModel;
  searching = false;
  promptToCreateNewVehicle: boolean = false;
  onNewVehicle: Function;
  isProvider: boolean = false;

  @ViewChild('searchBar') searchbar;

  constructor(
    navCtrl: NavController,
    navParams: NavParams,
    private viewCtrl: ViewController,
    private analytics: AnalyticsProvider,
    private opsService: OpsProvider
  ) {
    this.type = navParams.get('type');
    this.account = navParams.get('account');
    this.onNewVehicle = navParams.get('onNewVehicle');
    this.isProvider = navParams.get('isProvider');
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad VehicleAutocompletePage');
    this.analytics.trackView('VehicleAutocompletePage');
  }

  ionViewDidEnter() {
    this.searchbar.setFocus();
  }

  // Actions

  didTapDismiss() {
    this.viewCtrl.dismiss();
  }

  didSelectItem(vehicle: OpsVehicleModel) {
    this.viewCtrl.dismiss(vehicle);
  }

  didTapNewVehicle() {
    this.viewCtrl.dismiss();
    if (this.onNewVehicle) {
      this.onNewVehicle(this.type, this.query);
    }
  }

  searchBarDidUpdate() {
    if (!this.query && this.query.trim().length) {
      this.promptToCreateNewVehicle = false;
      this.vehicles = [];
      return;
    }
    this.searching = true;
    this.opsService
      .vehicleLookup(this.account, this.type, this.query)
      .finally(() => (this.searching = false))
      .subscribe((vehicles = []) => {
        this.vehicles = vehicles.length
          ? vehicles.slice(0, this.MAX_SEARCH_RESULTS)
          : [];
        this.promptToCreateNewVehicle = !this.vehicles.length;
      });
  }
}



// WEBPACK FOOTER //
// ./src/pages/vehicle-autocomplete/vehicle-autocomplete.ts